module.exports = __webpack_public_path__ + "assets/img/10.dc2df357.png";